module.exports = __webpack_public_path__ + "img/2019homepark-2.a08e4953.jpeg";